// Haute Galerie - Georg Esco
// Collection complète de 60 œuvres d'art - Multilingue
// Technique : Acrylique sur toile, livrée sans châssis ni cadre

// Traductions des techniques et mentions légales
export const techniqueTr = {
  fr: 'Acrylique sur toile',
  en: 'Acrylic on canvas',
  zh: '帆布上的丙烯',
  ja: 'キャンバスにアクリル',
  es: 'Acrílico sobre lienzo',
  ro: 'Acrilic pe pânză',
  ar: 'أكريليك على قماش',
  ru: 'Акрил на холсте'
};

export const legalMentionTr = {
  fr: 'Acrylique sur toile, livrée sans châssis ni cadre',
  en: 'Acrylic on canvas, delivered without stretcher or frame',
  zh: '帆布上的丙烯，不带担架或框架交付',
  ja: 'キャンバスにアクリル、ストレッチャーやフレームなしで配送',
  es: 'Acrílico sobre lienzo, entregado sin bastidor ni marco',
  ro: 'Acrilic pe pânză, livrat fără ramă sau șasiu',
  ar: 'أكريليك على قماش، يتم التسليم بدون إطار أو نقالة',
  ru: 'Акрил на холсте, поставляется без подрамника и рамы'
};

// Fonction helper pour déterminer la collection selon les dimensions
const getCollection = (dimensions) => {
  const matches = dimensions.match(/(\d+(?:[.,]\d+)?)/g);
  if (!matches) return 'fragments';
  
  const maxDim = Math.max(...matches.map(d => parseFloat(d.replace(',', '.'))));
  
  if (maxDim > 60) return 'prestige';
  if (maxDim >= 45) return 'signature';
  return 'fragments';
};

export const shopArtworks = [
  {
    id: '01',
    title: {
      fr: 'Fenêtre sur Paix',
      en: 'Window on Peace',
      zh: '和平之窗',
      ja: '平和への窓',
      es: 'Ventana hacia la Paz',
      ro: 'Fereastră spre Pace',
      ru: 'Окно в мир',
    
      ar: 'نافذة على السلام'},
    dimensions: '48 x 34 cm',
    price: 550,
    collection: getCollection('48 x 34 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/l98bzylo_1000017244.jpg'
  },
  {
    id: '02',
    title: {
      fr: 'Petite Étude I',
      en: 'Small Study I',
      zh: '小研究 I',
      ja: '小さな研究 I',
      es: 'Pequeño Estudio I',
      ro: 'Studiu Mic I',
      ru: 'Малый этюд I',
    
      ar: 'دراسة صغيرة I'},
    dimensions: '29,5 x 41 cm',
    price: 450,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ajziq384_1000017245.jpg'
  },
  {
    id: '03',
    title: {
      fr: 'Pensée I',
      en: 'Thought I',
      zh: '思想 I',
      ja: '思考 I',
      es: 'Pensamiento I',
      ro: 'Gând I',
      ru: 'Мысль I',
    
      ar: 'فكرة I'},
    dimensions: '38 x 29 cm',
    price: 450,
    collection: getCollection('38 x 29 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7fqmbfjs_1000017246.jpg'
  },
  {
    id: '04',
    title: {
      fr: 'Essence',
      en: 'Essence',
      zh: '本质',
      ja: 'エッセンス',
      es: 'Esencia',
      ro: 'Esență',
      ru: 'Сущность',
    
      ar: 'الجوهر'},
    dimensions: '29,5 x 41 cm',
    price: 350,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/acajkp5u_1000017247.jpg'
  },
  {
    id: '05',
    title: {
      fr: 'Murmure I',
      en: 'Whisper I',
      zh: '低语 I',
      ja: 'ささやき I',
      es: 'Susurro I',
      ro: 'Șoapte I',
      ru: 'Шепот I',
    
      ar: 'همسة I'},
    dimensions: '29,5 x 41 cm',
    price: 450,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/32qanw0y_1000017248.jpg'
  },
  {
    id: '06',
    title: {
      fr: 'Intuition',
      en: 'Intuition',
      zh: '直觉',
      ja: '直感',
      es: 'Intuición',
      ro: 'Intuiție',
      ru: 'Интуиция',
    
      ar: 'الحدس'},
    dimensions: '29,5 x 41 cm',
    price: 350,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/05ybi3lf_1000017249.jpg'
  },
  {
    id: '07',
    title: {
      fr: 'Petite Étude II',
      en: 'Small Study II',
      zh: '小研究 II',
      ja: '小さな研究 II',
      es: 'Pequeño Estudio II',
      ro: 'Studiu Mic II',
      ru: 'Малый этюд II',
    
      ar: 'دراسة صغيرة II'},
    dimensions: '29,5 x 41 cm',
    price: 350,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/n6p27iou_1000017250.jpg'
  },
  {
    id: '08',
    title: {
      fr: 'Murmure II',
      en: 'Whisper II',
      zh: '低语 II',
      ja: 'ささやき II',
      es: 'Susurro II',
      ro: 'Șoapte II',
      ru: 'Шепот II',
    
      ar: 'همسة II'},
    dimensions: '29,5 x 41 cm',
    price: 350,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/5w6atkb7_1000017251.jpg'
  },
  {
    id: '09',
    title: {
      fr: 'Pensée II',
      en: 'Thought II',
      zh: '思想 II',
      ja: '思考 II',
      es: 'Pensamiento II',
      ro: 'Gând II',
      ru: 'Мысль II',
    
      ar: 'فكرة II'},
    dimensions: '29,5 x 41 cm',
    price: 350,
    collection: getCollection('29,5 x 41 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2tx3fyy4_1000017252.jpg'
  },
  {
    id: '10',
    title: {
      fr: 'Miniature',
      en: 'Miniature',
      zh: '微型',
      ja: 'ミニチュア',
      es: 'Miniatura',
      ro: 'Miniatură',
      ru: 'Миниатюра',
    
      ar: 'مصغرة'},
    dimensions: '29 x 39,5 cm',
    price: 350,
    collection: getCollection('29 x 39,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ekes621f_1000017253.jpg'
  },
  {
    id: '11',
    title: {
      fr: 'Éclat',
      en: 'Radiance',
      zh: '光辉',
      ja: '輝き',
      es: 'Resplandor',
      ro: 'Strălucire',
      ru: 'Сияние',
    
      ar: 'بريق'},
    dimensions: '32 x 37 cm',
    price: 250,
    collection: getCollection('32 x 37 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ctr9k38y_1000017254.jpg'
  },
  {
    id: '12',
    title: {
      fr: 'Pensée III',
      en: 'Thought III',
      zh: '思想 III',
      ja: '思考 III',
      es: 'Pensamiento III',
      ro: 'Gând III',
      ru: 'Мысль III',
    
      ar: 'فكرة III'},
    dimensions: '32 x 37 cm',
    price: 250,
    collection: getCollection('32 x 37 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/85lcv8py_1000017255.jpg'
  },
  {
    id: '13',
    title: {
      fr: 'Sagesse Orientale',
      en: 'Oriental Wisdom',
      zh: '东方智慧',
      ja: '東洋の叡智',
      es: 'Sabiduría Oriental',
      ro: 'Înțelepciune Orientală',
      ru: 'Восточная мудрость',
    
      ar: 'حكمة شرقية'},
    dimensions: '37 x 32 cm',
    price: 250,
    collection: getCollection('37 x 32 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/hyf6o84n_1000017256.jpg'
  },
  {
    id: '14',
    title: {
      fr: 'L\'Empreinte',
      en: 'The Imprint',
      zh: '印记',
      ja: '刻印',
      es: 'La Huella',
      ro: 'Amprenta',
      ru: 'Отпечаток',
      ar: 'الطبع'
    },
    dimensions: '32 x 37 cm',
    price: 250,
    collection: getCollection('32 x 37 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/fqe4q8su_1000017257.jpg'
  },
  {
    id: '15',
    title: {
      fr: 'Séquence I',
      en: 'Sequence I',
      zh: '序列 I',
      ja: 'シーケンス I',
      es: 'Secuencia I',
      ro: 'Secvență I',
      ru: 'Последовательность I',
    
      ar: 'تسلسل I'},
    dimensions: '37 x 32 cm',
    price: 250,
    collection: getCollection('37 x 32 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3kb29e5j_1000017258.jpg'
  },
  {
    id: '16',
    title: {
      fr: 'Séquence II',
      en: 'Sequence II',
      zh: '序列 II',
      ja: 'シーケンス II',
      es: 'Secuencia II',
      ro: 'Secvență II',
      ru: 'Последовательность II',
    
      ar: 'تسلسل II'},
    dimensions: '32 x 37 cm',
    price: 200,
    collection: getCollection('32 x 37 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/o9pl0y18_1000017259.jpg'
  },
  {
    id: '17',
    title: {
      fr: 'Séquence III',
      en: 'Sequence III',
      zh: '序列 III',
      ja: 'シーケンス III',
      es: 'Secuencia III',
      ro: 'Secvență III',
      ru: 'Последовательность III',
    
      ar: 'تسلسل III'},
    dimensions: '31,5 x 35 cm',
    price: 200,
    collection: getCollection('31,5 x 35 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/9xogc4mb_1000017260.jpg'
  },
  {
    id: '18',
    title: {
      fr: 'Séquence IV',
      en: 'Sequence IV',
      zh: '序列 IV',
      ja: 'シーケンス IV',
      es: 'Secuencia IV',
      ro: 'Secvență IV',
      ru: 'Последовательность IV',
    
      ar: 'تسلسل IV'},
    dimensions: '26,5 x 34,5 cm',
    price: 250,
    collection: getCollection('26,5 x 34,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2n7gynn5_1000017261.jpg'
  },
  {
    id: '19',
    title: {
      fr: 'Séquence V',
      en: 'Sequence V',
      zh: '序列 V',
      ja: 'シーケンス V',
      es: 'Secuencia V',
      ro: 'Secvență V',
      ru: 'Последовательность V',
    
      ar: 'تسلسل V'},
    dimensions: '43 x 49 cm',
    price: 200,
    collection: getCollection('43 x 49 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/qwm7kedm_1000017262.jpg'
  },
  {
    id: '20',
    title: {
      fr: 'Séquence VI',
      en: 'Sequence VI',
      zh: '序列 VI',
      ja: 'シーケンス VI',
      es: 'Secuencia VI',
      ro: 'Secvență VI',
      ru: 'Последовательность VI',
    
      ar: 'تسلسل VI'},
    dimensions: '32 x 35 cm',
    price: 350,
    collection: getCollection('32 x 35 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/jjdsy7on_1000017263.jpg'
  },
  {
    id: '21',
    title: {
      fr: 'RÉSERVÉ',
      en: 'RESERVED',
      zh: '保留',
      ja: '予約済み',
      es: 'RESERVADO',
      ro: 'REZERVAT',
      ru: 'ЗАРЕЗЕРВИРОВАНО',
    
      ar: 'محجوز'},
    dimensions: 'N/A',
    price: 0,
    collection: 'reserved',
    image: null,
    isReserved: true
  },
  {
    id: '22',
    title: {
      fr: 'Vision I',
      en: 'Vision I',
      zh: '愿景 I',
      ja: 'ビジョン I',
      es: 'Visión I',
      ro: 'Viziune I',
      ru: 'Видение I',
    
      ar: 'رؤية I'},
    dimensions: '33 x 50 cm',
    price: 400,
    collection: getCollection('50 x 33 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/1qcyp21a_1000017260.jpg'
  },
  {
    id: '23',
    title: {
      fr: 'Vision II',
      en: 'Vision II',
      zh: '愿景 II',
      ja: 'ビジョン II',
      es: 'Visión II',
      ro: 'Viziune II',
      ru: 'Видение II',
    
      ar: 'رؤية II'},
    dimensions: '43 x 49 cm',
    price: 340,
    collection: getCollection('49 x 43 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/tubbakhw_1000017261.jpg'
  },
  {
    id: '24',
    title: {
      fr: 'Élévation Mystique',
      en: 'Mystical Elevation',
      zh: '神秘的提升',
      ja: '神秘的な昇華',
      es: 'Elevación Mística',
      ro: 'Elevare Mistică',
      ru: 'Мистическое возвышение',
    
      ar: 'ارتفاع صوفي'},
    dimensions: '42 x 49,50 cm',
    price: 360,
    collection: getCollection('49,5 x 42 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/4sxmqcc7_1000017262.jpg'
  },
  {
    id: '25',
    title: {
      fr: 'Identité',
      en: 'Identity',
      zh: '身份',
      ja: 'アイデンティティ',
      es: 'Identidad',
      ro: 'Identitate',
      ru: 'Идентичность',
    
      ar: 'هوية'},
    dimensions: '43 x 49,50 cm',
    price: 300,
    collection: getCollection('49,5 x 43 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/cmec55zs_1000017263.jpg'
  },
  {
    id: '26',
    title: {
      fr: 'Unité Sacrée',
      en: 'Sacred Unity',
      zh: '神圣统一',
      ja: '神聖なる統一',
      es: 'Unidad Sagrada',
      ro: 'Unitate Sacră',
      ru: 'Священное единство',
    
      ar: 'وحدة مقدسة'},
    dimensions: '39,5 x 50,5 cm',
    price: 400,
    collection: getCollection('50,5 x 39,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/xbkv80qm_1000017264.jpg'
  },
  {
    id: '27',
    title: {
      fr: 'Géométrie de l\'Âme I',
      en: 'Geometry of the Soul I',
      zh: '灵魂的几何 I',
      ja: '魂の幾何学 I',
      es: 'Geometría del Alma I',
      ro: 'Geometria Sufletului I',
      ru: 'Геометрия души I',
      ar: 'هندسة الروح I'
    },
    dimensions: '40,5 x 50,5 cm',
    price: 450,
    collection: getCollection('50,5 x 40,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/65ggb6i8_1000017269.jpg'
  },
  {
    id: '28',
    title: {
      fr: 'Géométrie de l\'Âme II',
      en: 'Geometry of the Soul II',
      zh: '灵魂的几何 II',
      ja: '魂の幾何学 II',
      es: 'Geometría del Alma II',
      ro: 'Geometria Sufletului II',
      ru: 'Геометрия души II',
      ar: 'هندسة الروح II'
    },
    dimensions: '38 x 57,5 cm',
    price: 650,
    collection: getCollection('57,5 x 38 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/go24kc08_1000017270.jpg'
  },
  {
    id: '29',
    title: {
      fr: 'Horizon de Mémoire I',
      en: 'Horizon of Memory I',
      zh: '记忆的地平线 I',
      ja: '記憶の地平線 I',
      es: 'Horizonte de Memoria I',
      ro: 'Orizont de Memorie I',
      ru: 'Горизонт памяти I',
    
      ar: 'أفق الذاكرة I'},
    dimensions: '43 x 64,5 cm',
    price: 500,
    collection: getCollection('64,5 x 43 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/jxf7th6i_1000017271.jpg'
  },
  {
    id: '30',
    title: {
      fr: 'Horizon de Mémoire II',
      en: 'Horizon of Memory II',
      zh: '记忆的地平线 II',
      ja: '記憶の地平線 II',
      es: 'Horizonte de Memoria II',
      ro: 'Orizont de Memorie II',
      ru: 'Горизонт памяти II',
    
      ar: 'أفق الذاكرة II'},
    dimensions: '56 x 46,5 cm',
    price: 560,
    collection: getCollection('56 x 46,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/tv238wnm_1000017272.jpg'
  },
  {
    id: '31',
    title: {
      fr: 'Carré de Lumière',
      en: 'Square of Light',
      zh: '光之方',
      ja: '光の広場',
      es: 'Cuadrado de Luz',
      ro: 'Pătratul Luminii',
      ru: 'Квадрат света',
    
      ar: 'مربع النور'},
    dimensions: '45 x 60 cm',
    price: 650,
    collection: getCollection('60 x 45 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/rntv8r2q_1000017273.jpg'
  },
  {
    id: '32',
    title: {
      fr: 'Résonance Intérieure I',
      en: 'Inner Resonance I',
      zh: '内在共鸣 I',
      ja: '内なる共鳴 I',
      es: 'Resonancia Interior I',
      ro: 'Rezonanță Interioară I',
      ru: 'Внутренний резонанс I',
    
      ar: 'صدى داخلي I'},
    dimensions: '44,5 x 59,5 cm',
    price: 400,
    collection: getCollection('59,5 x 44,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/qvh41rmf_1000017274.jpg'
  },
  {
    id: '33',
    title: {
      fr: 'L\'Absolu',
      en: 'The Absolute',
      zh: '绝对',
      ja: '絶対',
      es: 'Lo Absoluto',
      ro: 'Absolutul',
      ru: 'Абсолют',
      ar: 'المطلق'
    },
    dimensions: '49 x 64 cm',
    price: 1200,
    collection: getCollection('64 x 49 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/20jgv5cc_1000017275.jpg'
  },
  {
    id: '34',
    title: {
      fr: 'Présence Totale',
      en: 'Total Presence',
      zh: '全面存在',
      ja: '完全なる存在',
      es: 'Presencia Total',
      ro: 'Prezență Totală',
      ru: 'Полное присутствие',
    
      ar: 'حضور كامل'},
    dimensions: '47 x 55,5 cm',
    price: 550,
    collection: getCollection('55,5 x 47 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/uskflycq_1000017276.jpg'
  },
  {
    id: '35',
    title: {
      fr: 'Composition',
      en: 'Composition',
      zh: '构成',
      ja: 'コンポジション',
      es: 'Composición',
      ro: 'Compoziție',
      ru: 'Композиция',
    
      ar: 'تكوين'},
    dimensions: '64 x 62,5 cm',
    price: 550,
    collection: getCollection('64 x 62,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wkamvjvd_1000017277.jpg'
  },
  {
    id: '36',
    title: {
      fr: 'Regard Éternel',
      en: 'Eternal Gaze',
      zh: '永恒的注视',
      ja: '永遠の眼差し',
      es: 'Mirada Eterna',
      ro: 'Privire Eternă',
      ru: 'Вечный взгляд',
    
      ar: 'نظرة أبدية'},
    dimensions: '59 x 59,5 cm',
    price: 550,
    collection: getCollection('59,5 x 59 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ytnfnqbc_1000017278.jpg'
  },
  {
    id: '37',
    title: {
      fr: 'L\'Instant Suspendu',
      en: 'The Suspended Moment',
      zh: '悬浮的瞬间',
      ja: '停止した瞬間',
      es: 'El Instante Suspendido',
      ro: 'Momentul Suspendat',
      ru: 'Застывшее мгновение',
      ar: 'اللحظة المعلقة'
    },
    dimensions: '59,5 x 59,5 cm',
    price: 500,
    collection: getCollection('59,5 x 59,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/mzgt3uw9_1000017279.jpg'
  },
  {
    id: '38',
    title: {
      fr: 'Harmonie Vibrante I',
      en: 'Vibrant Harmony I',
      zh: '充满活力的和谐 I',
      ja: '振動する調和 I',
      es: 'Armonía Vibrante I',
      ro: 'Armonie Vibrantă I',
      ru: 'Вибрирующая гармония I',
    
      ar: 'انسجام نابض I'},
    dimensions: '52,5 x 70 cm',
    price: 650,
    collection: getCollection('70 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gk124nzz_1000017280.jpg'
  },
  {
    id: '39',
    title: {
      fr: 'Harmonie Vibrante II',
      en: 'Vibrant Harmony II',
      zh: '充满活力的和谐 II',
      ja: '振動する調和 II',
      es: 'Armonía Vibrante II',
      ro: 'Armonie Vibrantă II',
      ru: 'Вибрирующая гармония II',
    
      ar: 'انسجام نابض II'},
    dimensions: '52,5 x 69,5 cm',
    price: 650,
    collection: getCollection('69,5 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/vwclkdgw_1000017281.jpg'
  },
  {
    id: '40',
    title: {
      fr: 'Vibration de l\'Instant I',
      en: 'Vibration of the Moment I',
      zh: '瞬间的振动 I',
      ja: '瞬間の振動 I',
      es: 'Vibración del Instante I',
      ro: 'Vibrația Momentului I',
      ru: 'Вибрация мгновения I',
      ar: 'اهتزاز اللحظة I'
    },
    dimensions: '63 x 64 cm',
    price: 780,
    collection: getCollection('64 x 63 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/329i4w9z_1000017282.jpg'
  },
  {
    id: '41',
    title: {
      fr: 'Le Veilleur I',
      en: 'The Watcher I',
      zh: '守望者 I',
      ja: '見守る者 I',
      es: 'El Vigilante I',
      ro: 'Vegheatorul I',
      ru: 'Страж I',
    
      ar: 'الحارس I'},
    dimensions: '62 x 64 cm',
    price: 700,
    collection: getCollection('64 x 62 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/enaoof4u_1000017283.jpg'
  },
  {
    id: '42',
    title: {
      fr: 'Le Veilleur II',
      en: 'The Watcher II',
      zh: '守望者 II',
      ja: '見守る者 II',
      es: 'El Vigilante II',
      ro: 'Vegheatorul II',
      ru: 'Страж II',
    
      ar: 'الحارس II'},
    dimensions: '27 x 54,5 cm',
    price: 750,
    collection: getCollection('27 x 54,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/30mifvwi_1000017284.jpg'
  },
  {
    id: '43',
    title: {
      fr: 'Le Veilleur III',
      en: 'The Watcher III',
      zh: '守望者 III',
      ja: '見守る者 III',
      es: 'El Vigilante III',
      ro: 'Vegheatorul III',
      ru: 'Страж III',
    
      ar: 'الحارس III'},
    dimensions: '55 x 64,5 cm',
    price: 680,
    collection: getCollection('64,5 x 55 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/bduccnam_1000017285.jpg'
  },
  {
    id: '44',
    title: {
      fr: 'Le Veilleur IV',
      en: 'The Watcher IV',
      zh: '守望者 IV',
      ja: '見守る者 IV',
      es: 'El Vigilante IV',
      ro: 'Vegheatorul IV',
      ru: 'Страж IV',
    
      ar: 'الحارس IV'},
    dimensions: '51 x 57 cm',
    price: 850,
    collection: getCollection('57 x 51 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/exzck275_1000017286.jpg'
  },
  {
    id: '45',
    title: {
      fr: 'Résonance Intérieure II',
      en: 'Inner Resonance II',
      zh: '内在共鸣 II',
      ja: '内なる共鳴 II',
      es: 'Resonancia Interior II',
      ro: 'Rezonanță Interioară II',
      ru: 'Внутренний резонанс II',
    
      ar: 'صدى داخلي II'},
    dimensions: '54 x 69,5 cm',
    price: 850,
    collection: getCollection('69,5 x 54 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/n9ktfrza_1000017287.jpg'
  },
  {
    id: '46',
    title: {
      fr: 'Fragment de Paix I',
      en: 'Fragment of Peace I',
      zh: '和平碎片 I',
      ja: '平和の断片 I',
      es: 'Fragmento de Paz I',
      ro: 'Fragment de Pace I',
      ru: 'Фрагмент мира I',
    
      ar: 'شظية سلام I'},
    dimensions: '52,5 x 63,5 cm',
    price: 600,
    collection: getCollection('63,5 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/mpxgwp9y_1000017288.jpg'
  },
  {
    id: '47',
    title: {
      fr: 'Fragment de Paix II',
      en: 'Fragment of Peace II',
      zh: '和平碎片 II',
      ja: '平和の断片 II',
      es: 'Fragmento de Paz II',
      ro: 'Fragment de Pace II',
      ru: 'Фрагмент мира II',
    
      ar: 'شظية سلام II'},
    dimensions: '53 x 65 cm',
    price: 1100,
    collection: getCollection('65 x 53 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7l5noof6_1000017289.jpg'
  },
  {
    id: '48',
    title: {
      fr: 'Fragment de Paix III',
      en: 'Fragment of Peace III',
      zh: '和平碎片 III',
      ja: '平和の断片 III',
      es: 'Fragmento de Paz III',
      ro: 'Fragment de Pace III',
      ru: 'Фрагмент мира III',
    
      ar: 'شظية سلام III'},
    dimensions: '52,5 x 65 cm',
    price: 1260,
    collection: getCollection('65 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/lwtlm06b_1000017290.jpg'
  },
  {
    id: '49',
    title: {
      fr: 'Fragment de Paix IV',
      en: 'Fragment of Peace IV',
      zh: '和平碎片 IV',
      ja: '平和の断片 IV',
      es: 'Fragmento de Paz IV',
      ro: 'Fragment de Pace IV',
      ru: 'Фрагмент мира IV',
    
      ar: 'شظية سلام IV'},
    dimensions: '53 x 63 cm',
    price: 580,
    collection: getCollection('63 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/w8kgiobh_1000017291.jpg'
  },
  {
    id: '50',
    title: {
      fr: 'Fragment de Paix V',
      en: 'Fragment of Peace V',
      zh: '和平碎片 V',
      ja: '平和の断片 V',
      es: 'Fragmento de Paz V',
      ro: 'Fragment de Pace V',
      ru: 'Фрагмент мира V',
    
      ar: 'شظية سلام V'},
    dimensions: '52 x 58,5 cm',
    price: 650,
    collection: getCollection('58,5 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/6x2hvw5d_1000017292.jpg'
  },
  {
    id: '51',
    title: {
      fr: 'Fragment de Paix VI',
      en: 'Fragment of Peace VI',
      zh: '和平碎片 VI',
      ja: '平和の断片 VI',
      es: 'Fragmento de Paz VI',
      ro: 'Fragment de Pace VI',
      ru: 'Фрагмент мира VI',
    
      ar: 'شظية سلام VI'},
    dimensions: '52,5 x 69 cm',
    price: 700,
    collection: getCollection('69 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/v88vsk4b_1000017293.jpg'
  },
  {
    id: '52',
    title: {
      fr: 'Fragment de Paix VII',
      en: 'Fragment of Peace VII',
      zh: '和平碎片 VII',
      ja: '平和の断片 VII',
      es: 'Fragmento de Paz VII',
      ro: 'Fragment de Pace VII',
      ru: 'Фрагмент мира VII',
    
      ar: 'شظية سلام VII'},
    dimensions: '69 x 52,5 cm',
    price: 1100,
    collection: getCollection('69 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ox430p15_1000017294.jpg'
  },
  {
    id: '53',
    title: {
      fr: 'Fragment de Paix VIII',
      en: 'Fragment of Peace VIII',
      zh: '和平碎片 VIII',
      ja: '平和の断片 VIII',
      es: 'Fragmento de Paz VIII',
      ro: 'Fragment de Pace VIII',
      ru: 'Фрагмент мира VIII',
    
      ar: 'شظية سلام VIII'},
    dimensions: '53 x 68,5 cm',
    price: 600,
    collection: getCollection('68,5 x 53 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/1qe6gztf_1000017295.jpg'
  },
  {
    id: '54',
    title: {
      fr: 'Fragment de Paix IX',
      en: 'Fragment of Peace IX',
      zh: '和平碎片 IX',
      ja: '平和の断片 IX',
      es: 'Fragmento de Paz IX',
      ro: 'Fragment de Pace IX',
      ru: 'Фрагмент мира IX',
    
      ar: 'شظية سلام IX'},
    dimensions: '62,5 x 65 cm',
    price: 1650,
    collection: getCollection('62,5 x 65 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/pe15xme9_1000017296.jpg'
  },
  {
    id: '55',
    title: {
      fr: 'Vibration de l\'Instant II',
      en: 'Vibration of the Moment II',
      zh: '瞬间的振动 II',
      ja: '瞬間の振動 II',
      es: 'Vibración del Instante II',
      ro: 'Vibrația Momentului II',
      ru: 'Вибрация мгновения II',
      ar: 'اهتزاز اللحظة II'
    },
    dimensions: '52,5 x 63,5 cm',
    price: 650,
    collection: getCollection('63,5 x 52,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/hf793whu_1000017297.jpg'
  },
  {
    id: '56',
    title: {
      fr: 'Sérénité de Touche I',
      en: 'Serenity of Touch I',
      zh: '触摸的宁静 I',
      ja: 'タッチの静けさ I',
      es: 'Serenidad del Toque I',
      ro: 'Serenitate a Atingerii I',
      ru: 'Безмятежное прикосновение I',
    
      ar: 'صفاء اللمسة I'},
    dimensions: '49,5 x 58,5 cm',
    price: 450,
    collection: getCollection('58,5 x 49,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/vmdv82cb_1000017298.jpg'
  },
  {
    id: '57',
    title: {
      fr: 'Sérénité de Touche II',
      en: 'Serenity of Touch II',
      zh: '触摸的宁静 II',
      ja: 'タッチの静けさ II',
      es: 'Serenidad del Toque II',
      ro: 'Serenitate a Atingerii II',
      ru: 'Безмятежное прикосновение II',
    
      ar: 'صفاء اللمسة II'},
    dimensions: '49,5 x 58,5 cm',
    price: 450,
    collection: getCollection('58,5 x 49,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/xwf6jcdb_1000017299.jpg'
  },
  {
    id: '58',
    title: {
      fr: 'Équilibre Majeur',
      en: 'Major Balance',
      zh: '主要平衡',
      ja: '主要なバランス',
      es: 'Equilibrio Mayor',
      ro: 'Echilibru Major',
      ru: 'Главное равновесие',
    
      ar: 'توازن كبير'},
    dimensions: '69 x 50 cm',
    price: 580,
    collection: getCollection('69 x 50 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/t53a9ik6_1000017300.jpg'
  },
  {
    id: '59',
    title: {
      fr: 'Passage',
      en: 'Passage',
      zh: '通道',
      ja: '通路',
      es: 'Pasaje',
      ro: 'Pasaj',
      ru: 'Переход',
    
      ar: 'ممر'},
    dimensions: '59 x 64 cm',
    price: 450,
    collection: getCollection('64 x 59 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/zscymqsu_1000017301.jpg'
  },
  {
    id: '60',
    title: {
      fr: 'Sagesse du Carré',
      en: 'Wisdom of the Square',
      zh: '方形的智慧',
      ja: '正方形の知恵',
      es: 'Sabiduría del Cuadrado',
      ro: 'Înțelepciunea Pătratului',
      ru: 'Мудрость квадрата',
    
      ar: 'حكمة المربع'},
    dimensions: '67 x 94,5 cm',
    price: 1470,
    collection: getCollection('94,5 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/uhmi3zqq_1000017302.jpg'
  },
  {
    id: '61',
    title: {
      fr: 'Souffle de Paix',
      en: 'Breath of Peace',
      zh: '和平的气息',
      ja: '平和の息吹',
      es: 'Soplo de Paz',
      ro: 'Suflul Păcii',
      ru: 'Дыхание мира',
    
      ar: 'نفس السلام'},
    dimensions: '52 x 72 cm',
    price: 1190,
    collection: getCollection('52 x 72 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/14z4bhmt_1000017303.jpg'
  },
  {
    id: '62',
    title: {
      fr: 'L\'Étendue Silencieuse',
      en: 'The Silent Expanse',
      zh: '寂静的广阔',
      ja: '静かな広がり',
      es: 'La Extensión Silenciosa',
      ro: 'Întinderea Tăcută',
      ru: 'Безмолвная даль',
      ar: 'الامتداد الصامت'
    },
    dimensions: '70 x 125,5 cm',
    price: 2150,
    collection: getCollection('70 x 125,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/v5fyq0di_1000017640.jpg'
  },
  {
    id: '63',
    title: {
      fr: 'Résonance Murale',
      en: 'Wall Resonance',
      zh: '墙壁共鸣',
      ja: '壁の共鳴',
      es: 'Resonancia Mural',
      ro: 'Rezonanța Murală',
      ru: 'Настенный резонанс',
    
      ar: 'صدى جداري'},
    dimensions: '90,5 x 119 cm',
    price: 2700,
    collection: getCollection('90,5 x 119 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/15iciu4j_1000017641.jpg'
  },
  {
    id: '64',
    title: {
      fr: 'L\'Architecture du Regard',
      en: 'The Architecture of Gaze',
      zh: '凝视的建筑',
      ja: '視線の建築',
      es: 'La Arquitectura de la Mirada',
      ro: 'Arhitectura Privirii',
      ru: 'Архитектура взгляда',
      ar: 'هندسة النظرة'
    },
    dimensions: '99,5 x 82,5 cm',
    price: 2200,
    collection: getCollection('99,5 x 82,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/eoetradx_1000017642.jpg'
  },
  {
    id: '65',
    title: {
      fr: 'Passage Intérieur',
      en: 'Inner Passage',
      zh: '内在通道',
      ja: '内なる通路',
      es: 'Pasaje Interior',
      ro: 'Pasaj Interior',
      ru: 'Внутренний переход',
    
      ar: 'ممر داخلي'},
    dimensions: '61 x 73,5 cm',
    price: 1750,
    collection: getCollection('61 x 73,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/so98238c_1000017643.jpg'
  },
  {
    id: '66',
    title: {
      fr: 'Épure de Paix',
      en: 'Blueprint of Peace',
      zh: '和平的纯净',
      ja: '平和の簡素',
      es: 'Diseño de Paz',
      ro: 'Schița Păcii',
      ru: 'Очертание мира',
    
      ar: 'نقاء السلام'},
    dimensions: '35,5 x 32 cm',
    price: 650,
    collection: getCollection('35,5 x 32 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3xe6h72o_1000017644.jpg'
  },
  {
    id: '67',
    title: {
      fr: 'Géométrie de l\'Âme',
      en: 'Geometry of the Soul',
      zh: '灵魂的几何',
      ja: '魂の幾何学',
      es: 'Geometría del Alma',
      ro: 'Geometria Sufletului',
      ru: 'Геометрия души',
      ar: 'هندسة الروح'
    },
    dimensions: '66 x 75,5 cm',
    price: 1100,
    collection: getCollection('66 x 75,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7gy08fmo_1000017645.jpg'
  },
  {
    id: '68',
    title: {
      fr: 'Le Souffle des Cimes',
      en: 'The Breath of Peaks',
      zh: '山峰的呼吸',
      ja: '頂の息吹',
      es: 'El Aliento de las Cimas',
      ro: 'Suflul Vârfurilor',
      ru: 'Дыхание вершин',
    
      ar: 'نفس القمم'},
    dimensions: '57 x 67 cm',
    price: 1600,
    collection: getCollection('57 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/0nlx15nv_1000017648.jpg'
  },
  {
    id: '69',
    title: {
      fr: 'Trame de Vie',
      en: 'Life\'s Weft',
      zh: '生命的经纬',
      ja: '人生の織物',
      es: 'Trama de Vida',
      ro: 'Țesătura Vieții',
      ru: 'Ткань жизни',
    
      ar: 'نسيج الحياة'},
    dimensions: '49,5 x 59 cm',
    price: 1280,
    collection: getCollection('49,5 x 59 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/dokarswi_1000017649.jpg'
  },
  {
    id: '70',
    title: {
      fr: 'Verticalité Sacrée',
      en: 'Sacred Verticality',
      zh: '神圣的垂直',
      ja: '神聖な垂直性',
      es: 'Verticalidad Sagrada',
      ro: 'Verticalitate Sacră',
      ru: 'Священная вертикаль',
    
      ar: 'عمودية مقدسة'},
    dimensions: '52,5 x 72 cm',
    price: 1260,
    collection: getCollection('52,5 x 72 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/iz530ji8_1000017651.jpg'
  },
  {
    id: '71',
    title: {
      fr: 'L\'Éveil des Formes',
      en: 'The Awakening of Forms',
      zh: '形式的觉醒',
      ja: '形の目覚め',
      es: 'El Despertar de las Formas',
      ro: 'Trezirea Formelor',
      ru: 'Пробуждение форм',
      ar: 'صحوة الأشكال'
    },
    dimensions: '49,5 x 59 cm',
    price: 1460,
    collection: getCollection('49,5 x 59 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/sqnturdh_1000017654.jpg'
  },
  {
    id: '72',
    title: {
      fr: 'Horizon Intemporel',
      en: 'Timeless Horizon',
      zh: '永恒的地平线',
      ja: '時を超えた地平線',
      es: 'Horizonte Intemporal',
      ro: 'Orizont Atemporel',
      ru: 'Вечный горизонт',
    
      ar: 'أفق خالد'},
    dimensions: '49,5 x 59 cm',
    price: 1400,
    collection: getCollection('49,5 x 59 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wy3qwjav_1000017662.jpg'
  },
  {
    id: '73',
    title: {
      fr: 'La Force du Silence',
      en: 'The Strength of Silence',
      zh: '沉默的力量',
      ja: '沈黙の力',
      es: 'La Fuerza del Silencio',
      ro: 'Puterea Tăcerii',
      ru: 'Сила тишины',
    
      ar: 'قوة الصمت'},
    dimensions: '58 x 67 cm',
    price: 1200,
    collection: getCollection('58 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/6sxxruya_1000017663.jpg'
  },
  {
    id: '74',
    title: {
      fr: 'L\'Infinie Présence',
      en: 'Infinite Presence',
      zh: '无限的存在',
      ja: '無限の存在',
      es: 'La Presencia Infinita',
      ro: 'Prezența Infinită',
      ru: 'Бесконечное присутствие',
      ar: 'الحضور اللانهائي'
    },
    dimensions: '69 x 71,5 cm',
    price: 1370,
    collection: getCollection('69 x 71,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/f3rgw5jg_1000017664.jpg'
  },
  {
    id: '75',
    title: {
      fr: 'Souvenir d\'Espace',
      en: 'Memory of Space',
      zh: '空间的记忆',
      ja: '空間の記憶',
      es: 'Recuerdo de Espacio',
      ro: 'Amintire de Spațiu',
      ru: 'Воспоминание о пространстве',
      ar: 'ذكرى الفضاء'
    },
    dimensions: '58,5 x 64 cm',
    price: 1380,
    collection: getCollection('58,5 x 64 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/33742ggn_1000017665.jpg'
  },
  {
    id: '76',
    title: {
      fr: 'L\'Unité Retrouvée',
      en: 'Unity Restored',
      zh: '重获的统一',
      ja: '取り戻された統一',
      es: 'La Unidad Recuperada',
      ro: 'Unitatea Regăsită',
      ru: 'Обретённое единство',
      ar: 'الوحدة المستعادة'
    },
    dimensions: '65 x 78,5 cm',
    price: 1600,
    collection: getCollection('65 x 78,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/scaw4gjk_1000017666.jpg'
  },
  {
    id: '77',
    title: {
      fr: 'Clarté Latente',
      en: 'Latent Clarity',
      zh: '潜在的清晰',
      ja: '潜在的な明晰さ',
      es: 'Claridad Latente',
      ro: 'Claritate Latentă',
      ru: 'Скрытая ясность',
    
      ar: 'وضوح كامن'},
    dimensions: '70 x 71,5 cm',
    price: 1350,
    collection: getCollection('70 x 71,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/d5bzx7lc_1000017655.jpg'
  },
  {
    id: '78',
    title: {
      fr: 'Miroir de Paix',
      en: 'Mirror of Peace',
      zh: '和平之镜',
      ja: '平和の鏡',
      es: 'Espejo de Paz',
      ro: 'Oglinda Păcii',
      ru: 'Зеркало мира',
    
      ar: 'مرآة السلام'},
    dimensions: '70 x 71,5 cm',
    price: 1300,
    collection: getCollection('70 x 71,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/guq7xe4m_1000017656.jpg'
  },
  {
    id: '79',
    title: {
      fr: 'Le Rythme des Songes',
      en: 'The Rhythm of Dreams',
      zh: '梦的节奏',
      ja: '夢のリズム',
      es: 'El Ritmo de los Sueños',
      ro: 'Ritmul Viselor',
      ru: 'Ритм грёз',
    
      ar: 'إيقاع الأحلام'},
    dimensions: '57 x 78 cm',
    price: 1400,
    collection: getCollection('57 x 78 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/jpz9xdhr_1000017667.jpg'
  },
  {
    id: '80',
    title: {
      fr: 'Éclat de Conscience',
      en: 'Burst of Consciousness',
      zh: '意识的闪耀',
      ja: '意識の輝き',
      es: 'Destello de Conciencia',
      ro: 'Strălucire de Conștiință',
      ru: 'Вспышка сознания',
    
      ar: 'وميض الوعي'},
    dimensions: '69,5 x 78 cm',
    price: 1450,
    collection: getCollection('69,5 x 78 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ns6ur7wr_1000017658.jpg'
  },
  {
    id: '81',
    title: {
      fr: 'Symphonie Minérale',
      en: 'Mineral Symphony',
      zh: '矿物交响曲',
      ja: '鉱物の交響曲',
      es: 'Sinfonía Mineral',
      ro: 'Simfonie Minerală',
      ru: 'Минеральная симфония',
    
      ar: 'سيمفونية معدنية'},
    dimensions: '75,5 x 104 cm',
    price: 1950,
    collection: getCollection('75,5 x 104 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/jewp6lm7_1000017659.jpg'
  },
  {
    id: '82',
    title: {
      fr: 'L\'Ancre de l\'Esprit',
      en: 'The Anchor of Spirit',
      zh: '精神之锚',
      ja: '精神の錨',
      es: 'El Ancla del Espíritu',
      ro: 'Ancora Spiritului',
      ru: 'Якорь духа',
      ar: 'مرساة الروح'
    },
    dimensions: '79 x 104 cm',
    price: 1670,
    collection: getCollection('79 x 104 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/p0pxfr3e_1000017660.jpg'
  },
  {
    id: '83',
    title: {
      fr: 'L\'Apothéose Blanche',
      en: 'The White Apotheosis',
      zh: '白色的神化',
      ja: '白の神格化',
      es: 'La Apoteosis Blanca',
      ro: 'Apoteoza Albă',
      ru: 'Белый апофеоз',
      ar: 'التأليه الأبيض'
    },
    dimensions: '75,5 x 104 cm',
    price: 1850,
    collection: getCollection('75,5 x 104 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/tcxt3ba8_1000017661.jpg'
  },
  {
    id: '84',
    title: {
      fr: 'L\'Éclat du Silence',
      en: 'The Radiance of Silence',
      zh: '沉默的光辉',
      ja: '沈黙の輝き',
      es: 'El Esplendor del Silencio',
      ro: 'Strălucirea Tăcerii',
      ru: 'Сияние тишины',
      ar: 'بريق الصمت'
    },
    dimensions: '32,5 x 42,5 cm',
    price: 280,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/9ul03y7n_1000018045.jpg'
  },
  {
    id: '85',
    title: {
      fr: 'Le Souffle du Temps',
      en: 'The Breath of Time',
      zh: '时间的气息',
      ja: '時の息吹',
      es: 'El Aliento del Tiempo',
      ro: 'Suflul Timpului',
      ru: 'Дыхание времени',
    
      ar: 'نفس الزمن'},
    dimensions: '52 x 67 cm',
    price: 670,
    collection: getCollection('52 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/pqim3mwq_1000018044.jpg'
  },
  {
    id: '86',
    title: {
      fr: 'L\'Ombre de la Paix',
      en: 'The Shadow of Peace',
      zh: '和平的阴影',
      ja: '平和の影',
      es: 'La Sombra de la Paz',
      ro: 'Umbra Păcii',
      ru: 'Тень мира',
      ar: 'ظل السلام'
    },
    dimensions: '52 x 67 cm',
    price: 680,
    collection: getCollection('52 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/8njso83f_1000018043.jpg'
  },
  {
    id: '87',
    title: {
      fr: 'Le Regard d\'Azur',
      en: 'The Azure Gaze',
      zh: '蔚蓝的凝视',
      ja: '蒼の眼差し',
      es: 'La Mirada Azul',
      ro: 'Privirea Azurie',
      ru: 'Лазурный взгляд',
      ar: 'نظرة اللازورد'
    },
    dimensions: '52 x 67 cm',
    price: 600,
    collection: getCollection('52 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/d44ib0en_1000018042.jpg'
  },
  {
    id: '88',
    title: {
      fr: 'Murmure de l\'Âme',
      en: 'Murmur of the Soul',
      zh: '灵魂的低语',
      ja: '魂のささやき',
      es: 'Murmullo del Alma',
      ro: 'Murmur al Sufletului',
      ru: 'Шёпот души',
      ar: 'همس الروح'
    },
    dimensions: '67 x 52 cm',
    price: 560,
    collection: getCollection('67 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2evevvby_1000018041.jpg'
  },
  {
    id: '89',
    title: {
      fr: 'L\'Essence du Trait',
      en: 'The Essence of the Line',
      zh: '线的本质',
      ja: '線の本質',
      es: 'La Esencia del Trazo',
      ro: 'Esența Trăsăturii',
      ru: 'Сущность линии',
      ar: 'جوهر الخط'
    },
    dimensions: '52 x 67 cm',
    price: 600,
    collection: getCollection('52 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gfakiuq6_1000018039.jpg'
  },
  {
    id: '90',
    title: {
      fr: 'Éveil de Conscience',
      en: 'Awakening of Consciousness',
      zh: '意识的觉醒',
      ja: '意識の目覚め',
      es: 'Despertar de Conciencia',
      ro: 'Trezirea Conștiinței',
      ru: 'Пробуждение сознания',
    
      ar: 'يقظة الوعي'},
    dimensions: '52 x 67 cm',
    price: 680,
    collection: getCollection('52 x 67 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/nbkwaxbl_1000018038.jpg'
  },
  {
    id: '91',
    title: {
      fr: 'L\'Instant Suspendu',
      en: 'The Suspended Moment',
      zh: '悬浮的瞬间',
      ja: '凍りついた瞬間',
      es: 'El Instante Suspendido',
      ro: 'Momentul Suspendat',
      ru: 'Застывшее мгновение',
      ar: 'اللحظة المعلقة'
    },
    dimensions: '32,5 x 42,5 cm',
    price: 280,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/9uov8325_1000018037.jpg'
  },
  {
    id: '92',
    title: {
      fr: 'Sérénité de Plume',
      en: 'Serenity of Feather',
      zh: '羽毛的宁静',
      ja: '羽の静けさ',
      es: 'Serenidad de Pluma',
      ro: 'Serenitatea Penei',
      ru: 'Безмятежность пера',
    
      ar: 'صفاء الريشة'},
    dimensions: '32 x 41,5 cm',
    price: 400,
    collection: getCollection('32 x 41,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/se7a4y1q_1000018036.jpg'
  },
  {
    id: '93',
    title: {
      fr: 'La Clarté de l\'Esprit',
      en: 'The Clarity of Mind',
      zh: '心灵的清晰',
      ja: '精神の明晰',
      es: 'La Claridad del Espíritu',
      ro: 'Claritatea Minții',
      ru: 'Ясность духа',
      ar: 'وضوح العقل'
    },
    dimensions: '32,5 x 42,5 cm',
    price: 280,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/dwzxea0h_1000018035.jpg'
  },
  {
    id: '94',
    title: {
      fr: 'L\'Héritage de Lumière',
      en: 'The Heritage of Light',
      zh: '光的遗产',
      ja: '光の遺産',
      es: 'El Legado de Luz',
      ro: 'Moștenirea Luminii',
      ru: 'Наследие света',
      ar: 'إرث النور'
    },
    dimensions: '32,5 x 42,5 cm',
    price: 350,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/h2qvkqhy_1000018034.jpg'
  },
  {
    id: '95',
    title: {
      fr: 'Vision d\'Éternité',
      en: 'Vision of Eternity',
      zh: '永恒的视野',
      ja: '永遠の視界',
      es: 'Visión de Eternidad',
      ro: 'Viziunea Eternității',
      ru: 'Видение вечности',
      ar: 'رؤية الأبدية'
    },
    dimensions: '32,5 x 42,5 cm',
    price: 350,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/qmvr810j_1000018033.jpg'
  },
  {
    id: '96',
    title: {
      fr: 'Le Passage Sacré',
      en: 'The Sacred Passage',
      zh: '神圣的通道',
      ja: '聖なる通路',
      es: 'El Pasaje Sagrado',
      ro: 'Trecerea Sacră',
      ru: 'Священный переход',
    
      ar: 'الممر المقدس'},
    dimensions: '32,5 x 42,5 cm',
    price: 300,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7xz56gh0_1000018032.jpg'
  },
  {
    id: '97',
    title: {
      fr: 'L\'Harmonie Profonde',
      en: 'The Deep Harmony',
      zh: '深刻的和谐',
      ja: '深い調和',
      es: 'La Armonía Profunda',
      ro: 'Armonia Profundă',
      ru: 'Глубокая гармония',
      ar: 'الانسجام العميق'
    },
    dimensions: '32,5 x 42,5 cm',
    price: 380,
    collection: getCollection('32,5 x 42,5 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/cvsc8wmi_1000018031.jpg'
  },
  {
    id: '98',
    title: {
      fr: 'Le Chant de la Terre',
      en: 'The Song of the Earth',
      zh: '大地之歌',
      ja: '大地の歌',
      es: 'El Canto de la Tierra',
      ro: 'Cântul Pământului',
      ru: 'Песнь земли',
    
      ar: 'أغنية الأرض'},
    dimensions: '42 x 52 cm',
    price: 390,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/801vflgc_1000018030.jpg'
  },
  {
    id: '99',
    title: {
      fr: 'L\'Infini de Soie',
      en: 'The Infinity of Silk',
      zh: '丝绸的无限',
      ja: 'シルクの無限',
      es: 'El Infinito de Seda',
      ro: 'Infinitul de Mătase',
      ru: 'Шёлковая бесконечность',
      ar: 'ما لا نهاية من الحرير'
    },
    dimensions: '52 x 42 cm',
    price: 380,
    collection: getCollection('52 x 42 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ku4uvrxn_1000018029.jpg'
  },
  {
    id: '100',
    title: {
      fr: 'L\'Apothéose Finale',
      en: 'The Final Apotheosis',
      zh: '最终的神化',
      ja: '最終神格化',
      es: 'La Apoteosis Final',
      ro: 'Apoteoza Finală',
      ru: 'Финальный апофеоз',
      ar: 'التأليه النهائي'
    },
    dimensions: '52 x 42 cm',
    price: 390,
    collection: getCollection('52 x 42 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2mqlvp1f_1000018028.jpg'
  },
  {
    id: '101',
    title: {
      fr: 'L\'Envolée Lyrique',
      en: 'Lyrical Flight',
      zh: '抒情的飞翔',
      ja: '叙情的な飛翔',
      es: 'Vuelo Lírico',
      ro: 'Zbor Liric',
      ar: 'الطيران الغنائي',
      ru: 'Лирический взлет'
    },
    dimensions: '42 x 52 cm',
    price: 780,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/qnlbcrod_1000019120.jpg'
  },
  {
    id: '102',
    title: {
      fr: 'Force Intérieure',
      en: 'Inner Strength',
      zh: '内在力量',
      ja: '内なる力',
      es: 'Fuerza Interior',
      ro: 'Forță Interioară',
      ar: 'القوة الداخلية',
      ru: 'Внутренняя сила'
    },
    dimensions: '42 x 52 cm',
    price: 600,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/pun8yh4e_1000019121.jpg'
  },
  {
    id: '103',
    title: {
      fr: 'L\'Éclat de l\'Absolu',
      en: 'The Radiance of the Absolute',
      zh: '绝对的光辉',
      ja: '絶対の輝き',
      es: 'El Resplandor del Absoluto',
      ro: 'Strălucirea Absolutului',
      ar: 'بريق المطلق',
      ru: 'Сияние абсолюта'
    },
    dimensions: '42 x 52 cm',
    price: 620,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wus0ov5r_1000019122.jpg'
  },
  {
    id: '104',
    title: {
      fr: 'Résonance d\'Azur',
      en: 'Azure Resonance',
      zh: '蔚蓝共鸣',
      ja: '紺碧の共鳴',
      es: 'Resonancia de Azur',
      ro: 'Rezonanța Azurului',
      ar: 'صدى اللازورد',
      ru: 'Лазурный резонанс'
    },
    dimensions: '42 x 52 cm',
    price: 760,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/z8rv2wbc_1000019123.jpg'
  },
  {
    id: '105',
    title: {
      fr: 'Le Silence des Cimes',
      en: 'The Silence of the Peaks',
      zh: '山峰的沉默',
      ja: '頂の静けさ',
      es: 'El Silencio de las Cumbres',
      ro: 'Tăcerea Culmilor',
      ar: 'صمت القمم',
      ru: 'Молчание вершин'
    },
    dimensions: '42 x 52 cm',
    price: 760,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/geblo1ma_1000019124.jpg'
  },
  {
    id: '106',
    title: {
      fr: 'Mémoire de Terre',
      en: 'Memory of Earth',
      zh: '大地的记忆',
      ja: '大地の記憶',
      es: 'Memoria de Tierra',
      ro: 'Memoria Pământului',
      ar: 'ذاكرة الأرض',
      ru: 'Память земли'
    },
    dimensions: '42 x 52 cm',
    price: 780,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/x8t4382n_1000019125.jpg'
  },
  {
    id: '107',
    title: {
      fr: 'L\'Âme du Titan',
      en: 'The Soul of the Titan',
      zh: '泰坦之魂',
      ja: 'タイタンの魂',
      es: 'El Alma del Titán',
      ro: 'Sufletul Titanului',
      ar: 'روح التيتان',
      ru: 'Душа титана'
    },
    dimensions: '42 x 52 cm',
    price: 780,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/46bttfz6_1000019128.jpg'
  },
  {
    id: '108',
    title: {
      fr: 'Clarté Intérieure',
      en: 'Inner Clarity',
      zh: '内在的清晰',
      ja: '内なる明晰さ',
      es: 'Claridad Interior',
      ro: 'Claritate Interioară',
      ar: 'الوضوح الداخلي',
      ru: 'Внутренняя ясность'
    },
    dimensions: '42 x 52 cm',
    price: 650,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/n9g8ueiu_1000019129.jpg'
  },
  {
    id: '109',
    title: {
      fr: 'Reflet de Résilience',
      en: 'Reflection of Resilience',
      zh: '韧性的反映',
      ja: '回復力の反映',
      es: 'Reflejo de Resiliencia',
      ro: 'Reflexia Rezilienței',
      ar: 'انعكاس المرونة',
      ru: 'Отражение стойкости'
    },
    dimensions: '42 x 52 cm',
    price: 680,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/5qlrsht6_1000019130.jpg'
  },
  {
    id: '110',
    title: {
      fr: 'Le Souffle du Dragon',
      en: 'The Breath of the Dragon',
      zh: '龙之息',
      ja: '龍の息吹',
      es: 'El Soplo del Dragón',
      ro: 'Suflul Dragonului',
      ar: 'نفس التنين',
      ru: 'Дыхание дракона'
    },
    dimensions: '42 x 52 cm',
    price: 790,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/23148uld_1000019131.jpg'
  },
  {
    id: '111',
    title: {
      fr: 'Harmonie Sacrée',
      en: 'Sacred Harmony',
      zh: '神圣的和谐',
      ja: '神聖な調和',
      es: 'Armonía Sagrada',
      ro: 'Armonie Sacră',
      ar: 'الانسجام المقدس',
      ru: 'Священная гармония'
    },
    dimensions: '42 x 52 cm',
    price: 760,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ofxtqap7_1000019132.jpg'
  },
  {
    id: '112',
    title: {
      fr: 'Le Chant du Destin',
      en: 'The Song of Destiny',
      zh: '命运之歌',
      ja: '運命の歌',
      es: 'El Canto del Destino',
      ro: 'Cântecul Destinului',
      ar: 'أغنية القدر',
      ru: 'Песнь судьбы'
    },
    dimensions: '42 x 52 cm',
    price: 700,
    collection: getCollection('42 x 52 cm'),
    image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/o6pymgc8_1000019133.jpg'
  }
];

// Obtenir toutes les œuvres actives (sans les réservées)
export const getActiveArtworks = () => {
  return shopArtworks.filter(art => !art.isReserved);
};

// Grouper les œuvres par collection (en excluant les réservées)
export const getArtworksByCollection = () => {
  const activeArtworks = getActiveArtworks();
  return {
    prestige: activeArtworks.filter(art => art.collection === 'prestige').sort((a, b) => b.price - a.price),
    signature: activeArtworks.filter(art => art.collection === 'signature').sort((a, b) => b.price - a.price),
    fragments: activeArtworks.filter(art => art.collection === 'fragments').sort((a, b) => b.price - a.price)
  };
};

// Obtenir une œuvre par ID (en excluant les réservées)
export const getArtworkById = (id) => {
  const artwork = shopArtworks.find(art => art.id === id);
  return artwork?.isReserved ? null : artwork;
};

// Statistiques des collections
const activeArtworks = shopArtworks.filter(art => !art.isReserved);
const prestigeWorks = activeArtworks.filter(art => art.collection === 'prestige');
const signatureWorks = activeArtworks.filter(art => art.collection === 'signature');
const fragmentsWorks = activeArtworks.filter(art => art.collection === 'fragments');

export const collectionStats = {
  prestige: {
    count: prestigeWorks.length,
    priceRange: { 
      min: Math.min(...prestigeWorks.map(a => a.price)), 
      max: Math.max(...prestigeWorks.map(a => a.price)) 
    },
    description: 'Grands Formats — Œuvres de Prestige'
  },
  signature: {
    count: signatureWorks.length,
    priceRange: { 
      min: Math.min(...signatureWorks.map(a => a.price)), 
      max: Math.max(...signatureWorks.map(a => a.price)) 
    },
    description: 'Formats Intermédiaires — Série Signature'
  },
  fragments: {
    count: fragmentsWorks.length,
    priceRange: { 
      min: Math.min(...fragmentsWorks.map(a => a.price)), 
      max: Math.max(...fragmentsWorks.map(a => a.price)) 
    },
    description: 'Petits Formats — Série Fragments'
  }
};
